<button type="button" class="push-cta-close" [attr.aria-label]="'Close' | translate" (click)="onClose()">&times;</button>
@if (data.title) {
  <div class="push-cta-title">{{ data.title }}</div>
}
@if (data.body) {
  <div class="push-cta-body" [innerHTML]="data.body"></div>
}
@if (data.onConfirm) {
  <div class="push-cta-actions">
    <button type="button" class="push-cta-cancel" (click)="onClose()">{{ data.buttonCancel }}</button>
    <button type="button" class="push-cta-confirm" (click)="onConfirm()">{{ data.buttonConfirm }}</button>
  </div>
}
